export default __webpack_public_path__ + "static/media/756.5ce4bded.png";